import { render, staticRenderFns } from "./module-pricing.vue?vue&type=template&id=f3a83964"
import script from "./module-pricing.vue?vue&type=script&lang=js"
export * from "./module-pricing.vue?vue&type=script&lang=js"
import style0 from "./module-pricing.vue?vue&type=style&index=0&id=f3a83964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports